import React, { useRef } from 'react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import { isFunc } from '../../../../utils/functions';


const ValidatedTextInput = (props) => {
  const {
    value,
    onChange,
    style = {},
    fullWidth = false,
    validators = [],
    errorMessages = [],
    name = 'inputField',
    InputProps = {},
    inputProps: inputPropsProp,
    className,
    ref,
    'data-testid': dataTestId,
    ...other
  } = props;
  const fieldRef = useRef(null);
  const formRef = useRef(null);

  const { inputProps: nestedInputProps = {}, ...restInputProps } = InputProps ?? {};
  const combinedInputProps = {
    ...nestedInputProps,
    ...(inputPropsProp ?? {}),
  };

  if (dataTestId && combinedInputProps['data-testid'] === undefined) {
    combinedInputProps['data-testid'] = dataTestId;
  }

  const finalInputProps = { ...restInputProps };
  if (Object.keys(combinedInputProps).length) {
    finalInputProps.inputProps = combinedInputProps;
  }

  const hasCombinedInputProps = Object.keys(combinedInputProps).length > 0;

  const handleChange = (event) => {
    if (isFunc(onChange)) onChange(event);
  };

  return (
    <ValidatorForm onSubmit={() => {}} debounceTime={600} ref={formRef} style={{ width: '100%' }}>
      <TextValidator
        value={value}
        onChange={handleChange}
        fullWidth={fullWidth}
        style={style}
        variant="outlined"
        name={name}
        validators={validators}
        errorMessages={errorMessages}
        InputProps={Object.keys(finalInputProps).length ? finalInputProps : undefined}
        {...(hasCombinedInputProps ? { inputProps: combinedInputProps } : {})}
        ref={fieldRef}
        className={className}
        {...other}
      />
    </ValidatorForm>
  );
};

export default ValidatedTextInput;
